export default __webpack_public_path__ + "static/media/buttons-card-5-active.02f61617.svg";